import type { TagReading, TagResolved } from './shared'

export function Section({ title, note, count, action, children }: {
  title: string
  note?: string
  count?: number
  action?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <section className="bg-surface rounded-xl border border-gray-200 overflow-hidden">
      <header className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
        <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
        {count != null && <span className="text-xs text-gray-400">{count}</span>}
        {note && <span className="ml-auto text-xs text-gray-500">{note}</span>}
        {action && <span className={note ? '' : 'ml-auto'}>{action}</span>}
      </header>
      {children}
    </section>
  )
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs text-gray-400">{label}</dt>
      <dd className="text-gray-800 mt-0.5 break-words">{children}</dd>
    </div>
  )
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <div className="px-4 py-6 text-center text-sm text-gray-400">{children}</div>
}

// 연결 태그 — 코드 + 태그 설명. 디바이스에 없는 태그면 경고 (태그가 지워졌거나 코드가 바뀐 경우)
export function TagRef({ code, tag }: { code: string | null; tag: TagResolved }) {
  const shown = tag?.code ?? code
  if (!shown) return <span className="text-gray-300">-</span>
  return (
    <div className="min-w-0">
      <div className="font-mono text-xs text-gray-800 break-all">{shown}</div>
      {tag === null && <div className="text-xs text-amber-600 mt-0.5">디바이스에 없는 태그</div>}
      {tag?.description && <div className="text-xs text-gray-400 mt-0.5">{tag.description}</div>}
    </div>
  )
}

// 엣지와 같은 규칙 — 태그 값이 발생 값과 같으면 알람 발생 (MachineAlarmUnit)
export function AlarmState({ reading, alarmValue }: { reading: TagReading | null; alarmValue: string | null }) {
  if (!reading || alarmValue == null) return <span className="text-gray-300 text-xs">-</span>
  return reading.value === alarmValue
    ? <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">발생</span>
    : <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500">정상</span>
}
